export const getTrialCountdown = (trialEndDate: string | null): {
  daysRemaining: number;
  hoursRemaining: number;
  totalHoursRemaining: number;
  isExpiringSoon: boolean;
  isExpiredOrInvalid: boolean;
} => {
  if (!trialEndDate) {
    return {
      daysRemaining: 0,
      hoursRemaining: 0,
      totalHoursRemaining: 0,
      isExpiringSoon: false,
      isExpiredOrInvalid: true
    };
  }

  try {
    const end = new Date(trialEndDate);
    const now = new Date();
    const diffMs = end.getTime() - now.getTime();
    
    if (diffMs <= 0) {
      return {
        daysRemaining: 0,
        hoursRemaining: 0,
        totalHoursRemaining: 0,
        isExpiringSoon: true,
        isExpiredOrInvalid: true
      };
    }

    const totalHours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;

    return {
      daysRemaining: days,
      hoursRemaining: hours,
      totalHoursRemaining: totalHours,
      isExpiringSoon: days < 3,
      isExpiredOrInvalid: false
    };
  } catch (error) {
    console.error('Error parsing trial end date:', error);
    return {
      daysRemaining: 0,
      hoursRemaining: 0,
      totalHoursRemaining: 0,
      isExpiringSoon: false,
      isExpiredOrInvalid: true
    };
  }
};

export const formatTrialCountdown = (countdown: ReturnType<typeof getTrialCountdown>): string => {
  if (countdown.isExpiredOrInvalid) return 'Expired';
  
  const { daysRemaining, hoursRemaining } = countdown;
  
  if (daysRemaining > 0) {
    if (hoursRemaining > 0) {
      return `${daysRemaining}d ${hoursRemaining}h remaining`;
    }
    return `${daysRemaining} ${daysRemaining === 1 ? 'day' : 'days'} remaining`;
  }
  
  return `${hoursRemaining} ${hoursRemaining === 1 ? 'hour' : 'hours'} remaining`;
};
